import React from 'react';
import { Budget, ContributionCalculationType } from '../types/budget';
import { calculateBudgetSummary } from '../utils/budgetCalculations';
import { BudgetSummary } from './BudgetSummary';
import { TransactionList } from './TransactionList';

interface BudgetTransactionsProps {
  budget: Budget;
  showAddButton?: boolean;
}

export const BudgetTransactions: React.FC<BudgetTransactionsProps> = ({
  budget,
  showAddButton = true,
}) => {
  const contributionCalculationType =
    budget.settings?.contributionCalculationType ?? ContributionCalculationType.INCOME_RATIO;
  const summary = calculateBudgetSummary(budget.transactions, contributionCalculationType);

  return (
    <div className="grid grid-cols-1 gap-8">
      <div className="space-y-8">
        <BudgetSummary summary={summary} calculationType={contributionCalculationType} />
      </div>

      <div className="overflow-hidden rounded-lg bg-white shadow dark:bg-gray-800">
        <TransactionList budget={budget} showAddButton={showAddButton} />
      </div>
    </div>
  );
};
